export class LocalStorage {
    static store(key, data) {
        if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
            return;
        }
        localStorage.setItem(key, JSON.stringify(data));
    }
    static restore(key) {
        if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
            return;
        }
        const data = localStorage.getItem(key);
        if (!data) {
            return;
        }
        try {
            return JSON.parse(data);
        }
        catch (_e) {
            return;
        }
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/base/LocalStorage.js